import { History } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ActivityTimeline, useEntityActivityLogs } from '@/components/activity-log';

interface ActivityLogDetailProps {
  candidateId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const ActivityLogDetail = ({ candidateId, open, onOpenChange }: ActivityLogDetailProps) => {
  const { logs, loading } = useEntityActivityLogs('candidates', candidateId);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <History className="h-5 w-5" />
            Candidate Activity Log
          </DialogTitle>
        </DialogHeader>
        <ScrollArea className="max-h-[60vh] pr-4">
          <ActivityTimeline
            logs={logs}
            loading={loading}
            showEntityBadge={true}
            emptyMessage="No activity recorded for this candidate"
          />
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default ActivityLogDetail;
